import City from './city';
import District from './district';
import Town from './town';
import Warehouse from './warehouse';

const Address = (props) => {
  if (props.type === 'city') return <City {...props} />;

  if (props.type === 'town') return <Town {...props} />;

  if (props.type === 'district') return <District {...props} />;

  if (props.type === 'warehouse') return <Warehouse {...props} />;
};

export default Address;
